<template>
    <div v-if="isLoadingMore" class="loading-more">
        <LoadingSpinner />
        <div>Loading more {{ type }}...</div>
    </div>
    <div v-if="hasNoMore" class="no-more">
        No more {{ type }} to load
    </div>
</template>
<script>
import LoadingSpinner from '@/components/home/LoadingSpinner.vue';
export default {
    name: 'Loading',
    components: {
        LoadingSpinner
    },
    props: {
        type: {
            type: String,
            required: true
        },
        isLoadingMore: {
            type: Boolean,
            required: true
        },
        hasNoMore: {
            type: Boolean,
            required: true
        }
    }
}
</script>
<style lang="scss" scoped>
.loading-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #888;
    font-size: 14px;
}

.no-more {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 14px;
    font-style: italic;
}
</style>
